import { Component, HostListener, OnInit, OnDestroy } from '@angular/core';

import { trigger, transition, style, animate } from '@angular/animations';
import { Subject, takeUntil } from 'rxjs';
import { ChatUiStateService } from '../../services/chat-ui-state.service';
import { ChatUiState } from '../../models/chat.models';
import { ChatPanelComponent } from '../chat-panel/chat-panel.component';

/**
 * ChatWidgetComponent — Global floating chat widget.
 *
 * Renders a FAB button (bottom-right) and toggles the ChatPanel.
 * Should be placed once in AppComponent.
 */
@Component({
  selector: 'app-chat-widget',
  standalone: true,
  imports: [ChatPanelComponent],
  templateUrl: './chat-widget.component.html',
  styleUrls: ['./chat-widget.component.scss'],
  animations: [
    trigger('panelAnimation', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(20px) scale(0.95)' }),
        animate('200ms ease-out', style({ opacity: 1, transform: 'translateY(0) scale(1)' }))
      ]),
      transition(':leave', [
        animate('150ms ease-in', style({ opacity: 0, transform: 'translateY(20px) scale(0.95)' }))
      ])
    ])
  ]
})
export class ChatWidgetComponent implements OnInit, OnDestroy {

  uiState!: ChatUiState;
  private readonly destroy$ = new Subject<void>();

  constructor(private uiStateService: ChatUiStateService) {}

  ngOnInit(): void {
    this.uiStateService.state$
      .pipe(takeUntil(this.destroy$))
      .subscribe(state => this.uiState = state);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  toggle(): void {
    this.uiStateService.toggle();
  }

  /** Close panel on Escape key */
  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.uiState?.isOpen) {
      this.uiStateService.close();
    }
  }
}
